<script setup lang="ts">
import { useRoute } from 'vue-router'
import { keycloakReady } from '@/plugins/vuekeycloak'



const { keycloak, isAuthenticated } = useKeycloak()
const storeApp = useAppStore()
const storeU = useUtilisateurStore()
const router = useRouter()
const route = useRoute()

/** N'accepte qu'un chemin interne, pour éviter une redirection ouverte via `return_url`. */
function cheminDeRetour(): string {
  const url = route.query.return_url
  const valeur = Array.isArray(url) ? url[0] : url
  if (typeof valeur !== 'string') return '/'
  if (!valeur.startsWith('/') || valeur.startsWith('//')) return '/'
  return valeur
}

onMounted(async () => {
  // L'initialisation de Keycloak est asynchrone : sans cette attente, on redirigeait vers
  // l'écran de connexion (ou en boucle vers /login) alors que la session était encore valide.
  await keycloakReady

  const retour = cheminDeRetour()

  if (isAuthenticated.value) {
    if (!storeU.estChargé()) storeApp.showInitialLoader = true
    router.replace(retour)
    return
  }

  storeU.déconnexion()
  // Retour direct sur la page demandée : évite de repasser par /login après l'authentification.
  keycloak.value?.login({ redirectUri: window.location.origin + retour })
})
</script>

<template>
  <div />
</template>
